import { render, staticRenderFns } from "./a-item-info-contrast.vue?vue&type=template&id=70b87cb7&"
import script from "./a-item-info-contrast.vue?vue&type=script&lang=js&"
export * from "./a-item-info-contrast.vue?vue&type=script&lang=js&"
import style0 from "./a-item-info-contrast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports